export * from './assign-client-account-rights.component';
